<mat-nav-list
  class="sidenav-nav-list"
  disableRipple>
  <a
    mat-list-item
    #homeLink="routerLinkActive"
    class="nav-list-item"
    [class]="{ 'link-active': homeLink.isActive }"
    routerLink="/home"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    aria-label="Home"
    data-cy="nav-item-home">
    <mat-icon
      matListItemIcon
      class="nav-list-item-icon"
      [svgIcon]="homeLink.isActive ? 'home' : 'home-outline'"
      data-cy="home-icon"></mat-icon>
    <span
      class="nav-list-item-link-title"
      matListItemLine
      data-cy="home-link-title"
      >Home</span
    >
  </a>
  <a
    mat-list-item
    #livingLink="routerLinkActive"
    class="nav-list-item"
    [class]="{ 'link-active': livingLink.isActive }"
    routerLink="/living"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    aria-label="Living"
    data-cy="nav-item-living">
    <mat-icon
      matListItemIcon
      class="nav-list-item-icon"
      [svgIcon]="livingLink.isActive ? 'food' : 'food-outline'"
      data-cy="living-icon"></mat-icon>
    <span
      class="nav-list-item-link-title"
      matListItemLine
      data-cy="living-link-title"
      >Living</span
    >
  </a>
  <a
    mat-list-item
    #feesLink="routerLinkActive"
    class="nav-list-item"
    [class]="{ 'link-active': feesLink.isActive }"
    routerLink="/fees"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    aria-label="Fees"
    data-cy="nav-item-fees">
    <mat-icon
      matListItemIcon
      class="nav-list-item-icon"
      svgIcon="cash"
      data-cy="fees-icon"></mat-icon>
    <span
      class="nav-list-item-link-title"
      matListItemLine
      data-cy="fees-link-title"
      >Fees</span
    >
  </a>
  <a
    mat-list-item
    #tuitionLink="routerLinkActive"
    class="nav-list-item"
    [class]="{ 'link-active': tuitionLink.isActive }"
    routerLink="/tuition"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    aria-label="Tuition"
    data-cy="nav-item-tuition">
    <mat-icon
      matListItemIcon
      class="nav-list-item-icon"
      [svgIcon]="tuitionLink.isActive ? 'school' : 'school-outline'"
      data-cy="tution-icon"></mat-icon>
    <span
      class="nav-list-item-link-title"
      matListItemLine
      data-cy="tuition-link-title"
      >Tuition</span
    >
  </a>
</mat-nav-list>
